const RAW_INDUSTRY_LABELS = [
  "Crop Production",
  "Animal Production and Aquaculture",
  "Forestry and Logging",
  "Fishing, Hunting and Trapping",
  "Support Activities for Agriculture and Forestry",
  "Oil and Gas Extraction",
  "Mining (except Oil and Gas)",
  "Support Activities for Mining",
  "Utilities",
  "Construction of Buildings",
  "Heavy and Civil Engineering Construction",
  "Specialty Trade Contractors",
  "Food Manufacturing",
  "Beverage and Tobacco Product Manufacturing",
  "Textile Mills",
  "Textile Product Mills",
  "Apparel Manufacturing",
  "Leather and Allied Product Manufacturing",
  "Wood Product Manufacturing",
  "Paper Manufacturing",
  "Printing and Related Support Activities",
  "Petroleum and Coal Products Manufacturing",
  "Chemical Manufacturing",
  "Plastics and Rubber Products Manufacturing",
  "Nonmetallic Mineral Product Manufacturing",
  "Primary Metal Manufacturing",
  "Fabricated Metal Product Manufacturing",
  "Machinery Manufacturing",
  "Computer and Electronic Product Manufacturing",
  "Electrical Equipment, Appliance, and Component Manufacturing",
  "Transportation Equipment Manufacturing",
  "Furniture and Related Product Manufacturing",
  "Miscellaneous Manufacturing",
  "Merchant Wholesalers, Durable Goods",
  "Merchant Wholesalers, Nondurable Goods",
  "Wholesale Electronic Markets and Agents and Brokers",
  "Motor Vehicle and Parts Dealers",
  "Furniture and Home Furnishings Stores",
  "Electronics and Appliance Stores",
  "Building Material and Garden Equipment and Supplies Dealers",
  "Food and Beverage Stores",
  "Health and Personal Care Stores",
  "Gasoline Stations",
  "Clothing and Clothing Accessories Stores",
  "Sporting Goods, Hobby, Musical Instrument, and Book Stores",
  "General Merchandise Stores",
  "Miscellaneous Store Retailers",
  "Nonstore Retailers",
  "Air Transportation",
  "Rail Transportation",
  "Water Transportation",
  "Truck Transportation",
  "Transit and Ground Passenger Transportation",
  "Pipeline Transportation",
  "Scenic and Sightseeing Transportation",
  "Support Activities for Transportation",
  "Postal Service",
  "Couriers and Messengers",
  "Warehousing and Storage",
  "Publishing Industries (except Internet)",
  "Motion Picture and Sound Recording Industries",
  "Broadcasting (except Internet)",
  "Telecommunications",
  "Data Processing, Hosting, and Related Services",
  "Other Information Services",
  "Monetary Authorities-Central Bank",
  "Credit Intermediation and Related Activities",
  "Securities, Commodity Contracts, and Other Financial Investments and Related Activities",
  "Insurance Carriers and Related Activities",
  "Funds, Trusts, and Other Financial Vehicles",
  "Real Estate",
  "Rental and Leasing Services",
  "Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)",
  "Professional, Scientific, and Technical Services",
  "Management of Companies and Enterprises",
  "Administrative and Support Services",
  "Waste Management and Remediation Services",
  "Educational Services",
  "Ambulatory Health Care Services",
  "Hospitals",
  "Nursing and Residential Care Facilities",
  "Social Assistance",
  "Performing Arts, Spectator Sports, and Related Industries",
  "Museums, Historical Sites, and Similar Institutions",
  "Amusement, Gambling, and Recreation Industries",
  "Accommodation",
  "Food Services and Drinking Places",
  "Repair and Maintenance",
  "Personal and Laundry Services",
  "Religious, Grantmaking, Civic, Professional, and Similar Organizations",
  "Private Households",
  "Executive, Legislative, and Other General Government Support",
  "Justice, Public Order, and Safety Activities",
  "Administration of Human Resource Programs",
  "Administration of Environmental Quality Programs",
  "Administration of Housing Programs, Urban Planning, and Community Development",
  "Administration of Economic Programs",
  "Space Research and Technology",
  "National Security and International Affairs",
];

export const UNCLASSIFIED_INDUSTRY_VALUE = "__unclassified__";
export const UNCLASSIFIED_INDUSTRY_LABEL = "Unclassified";

const cleanIndustryValue = (value) => String(value || "").replace(/\s+/g, " ").trim();

const normalizeIndustryKey = (value) => cleanIndustryValue(value).toLowerCase();

const INDUSTRY_LABEL_BY_KEY = new Map(
  RAW_INDUSTRY_LABELS.map((label) => [normalizeIndustryKey(label), label]),
);

export const INDUSTRY_OPTIONS = RAW_INDUSTRY_LABELS.map((label) => ({ value: label, label }));
export const industryValueSet = new Set(INDUSTRY_OPTIONS.map((option) => option.value));

export const normalizeIndustry = (value) => {
  const cleaned = cleanIndustryValue(value);
  if (!cleaned) return "";
  return INDUSTRY_LABEL_BY_KEY.get(normalizeIndustryKey(cleaned)) || cleaned;
};

export const getIndustryLabel = (value) => normalizeIndustry(value) || UNCLASSIFIED_INDUSTRY_LABEL;

export const getIndustryOptions = (extraValues = []) => {
  const seen = new Set();
  const options = [];

  [...INDUSTRY_OPTIONS, ...extraValues.map((value) => ({ value, label: value }))].forEach((option) => {
    const normalized = normalizeIndustry(option?.value || option?.label);
    if (!normalized) return;
    const key = normalizeIndustryKey(normalized);
    if (seen.has(key)) return;
    seen.add(key);
    options.push({ value: normalized, label: getIndustryLabel(normalized) });
  });

  return options;
};
